import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VFooter } from 'vuetify/lib/components/VFooter';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VFooter,{attrs:{"padless":"","absolute":""}},[_c(VCard,{staticClass:"text-center fullwidth",attrs:{"flat":"","tile":""}},[_c(VDivider),_c(VCardText,[_vm._v(" "+_vm._s(new Date().getFullYear())+" — "),_c('strong',[_vm._v("Sparky")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }